const Urlencoder = (url) => {
    let newUrl = url.split('?')
    const decodedParams = atob(newUrl[1])

    let obj = {}
    if(decodedParams.includes('&')){
        let arr = decodedParams.split('&')
        for(let i=0;i<arr.length;i++){
            let paramsArr = arr[i].split('=')
            let newkey = paramsArr[0]
            let value = paramsArr[1]
            obj[newkey] = value
        }
    }else{
        let paramsArr = decodedParams.split('=')
        let newkey = paramsArr[0]
        let value = paramsArr[1]
        obj[newkey] = value
    }
    console.log(obj,"obj")
    return obj
};

export default Urlencoder;

